export default {
    data() {
        return {
            showDeleteUserAttentionModal: false,
            selectedUserForDelete: null,
        }
    },
    methods: {
        deleteUserAttention(userId) {
            this.showDeleteUserAttentionModal = true;
            this.selectedUserForDelete = userId;
        },
        deleteUser() {
            const userId = this.selectedUserForDelete || this.$route.params.userId;
            this.$axios.delete('/api/users/' + userId)
                .then(res => {
                    if (this.$route.params.userId) {
                        this.router.push('/users');
                    } else {
                        this.tableData = this.tableData.filter(user => user.id !== parseInt(userId))
                    }
                })
                .catch(({response}) => {
                    this.$notify({
                        title: response.data.message,
                        type: 'danger',
                    });
                })
                .then(() => {
                    this.selectedUserForDelete = null;
                    this.showDeleteUserAttentionModal = false;
                })
        }
    }
}
